import {Modal, Button, Image} from 'react-bootstrap'
import {useState} from 'react'

function ModalAlertWrapper({icon, title,  text}) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <a onClick={handleShow} className="mb-3 d-md-block d-flex p-3 align-items-center">
                <p className="mb-0 order-md-1 order-2">Join Our Community</p>
                <Image width={45} src="/images/sections/img-join-the-community01.svg" className="mr-md-0 mr-2"/>
            </a>

            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className="d-flex align-items-center h5">{icon} {title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{text}</Modal.Body>
            </Modal>
        </>
    
    );
}

export default ModalAlertWrapper;